var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app', [_c('app-header', {
    attrs: {
      "fixed": "",
      "mobile-logo": false
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function (_ref) {
        var isDesktop = _ref.isDesktop;
        return [_c('div', {
          staticClass: "h-full flex"
        }, [isDesktop ? [_vm._l(_vm.navItems, function (navItem) {
          return [navItem.items ? [_c('btn', {
            staticClass: "h-full",
            attrs: {
              "to": navItem.to,
              "exact": navItem.exact,
              "tile": "",
              "plain": "",
              "active-color": "primary"
            }
          }, [_vm._v("\n                                " + _vm._s(navItem.text) + "\n                            ")]), _vm._v(" "), _vm.$route.path.startsWith(navItem.to) ? [_c('div', {
            staticClass: "flex items-center justify-center h-full w-8"
          }, [_c('divider')], 1), _vm._v(" "), _vm._l(navItem.items, function (item, i) {
            return _c('btn', {
              key: i,
              staticClass: "h-full",
              attrs: {
                "to": item.to,
                "exact": item.exact,
                "tile": "",
                "plain": "",
                "active-color": "primary"
              }
            }, [_vm._v("\n                                    " + _vm._s(item.text) + "\n                                ")]);
          })] : _vm._e()] : _c('btn', {
            staticClass: "h-full",
            attrs: {
              "to": navItem.to,
              "exact": navItem.exact,
              "tile": "",
              "plain": "",
              "active-color": "primary"
            }
          }, [_vm._v("\n                            " + _vm._s(navItem.text) + "\n                        ")]), _vm._v(" "), _c('divider', {
            attrs: {
              "vertical": "",
              "margin": "8"
            }
          })];
        }), _vm._v(" "), _c('div', {
          staticClass: "h-full flex items-center"
        }, [_c('btn', {
          attrs: {
            "to": _vm.$config.spoferanUrl,
            "text": "",
            "exact": ""
          }
        }, [_vm._v(_vm._s(_vm.$t('action.to_spoferan')))])], 1)] : _c('div', {
          staticClass: "h-full flex items-center justify-center pl-16 sm:pl-0"
        }, [_c('lazy-menu-btn', {
          model: {
            value: _vm.isMobileSidebarVisible,
            callback: function ($$v) {
              _vm.isMobileSidebarVisible = $$v;
            },
            expression: "isMobileSidebarVisible"
          }
        })], 1)], 2)];
      }
    }])
  }), _vm._v(" "), _c('app-content', [_c('client-only', [_vm.$breakpoint.mdAndDown ? _c('lazy-app-sidebar', {
    attrs: {
      "items": _vm.sidebarItems,
      "large": "",
      "width": "250"
    },
    on: {
      "update:items": function ($event) {
        _vm.sidebarItems = $event;
      }
    },
    model: {
      value: _vm.isMobileSidebarVisible,
      callback: function ($$v) {
        _vm.isMobileSidebarVisible = $$v;
      },
      expression: "isMobileSidebarVisible"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('nuxt')], 1), _vm._v(" "), _c('app-footer', {
    attrs: {
      "items": _vm.footerItems,
      "without-bottom-padding": ""
    }
  }), _vm._v(" "), _c('client-only', [_c('cookie-banner')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }